import { render, staticRenderFns } from "./ChamadaRenovacao.vue?vue&type=template&id=9f1effcc&scoped=true&"
import script from "./ChamadaRenovacao.vue?vue&type=script&lang=js&"
export * from "./ChamadaRenovacao.vue?vue&type=script&lang=js&"
import style0 from "./ChamadaRenovacao.vue?vue&type=style&index=0&id=9f1effcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1effcc",
  null
  
)

export default component.exports